import { render, staticRenderFns } from "./UnionPay.vue?vue&type=template&id=46199636"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46199636')) {
      api.createRecord('46199636', component.options)
    } else {
      api.reload('46199636', component.options)
    }
    module.hot.accept("./UnionPay.vue?vue&type=template&id=46199636", function () {
      api.rerender('46199636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/paymentCards/UnionPay.vue"
export default component.exports